define('collections/commons/timezone',[
    'jquery',
    'underscore',
    'backbone',
    // models
    'models/commons/timezone',
    // datafiles
    'text!assets/datafiles/timezones.json'
], function($, _, Backbone, MTimezone, TimezonesData) {

    var data = $.parseJSON(TimezonesData);

    var CTimezone = Backbone.Collection.extend({
        url: 'assets/datafiles/timezones.json',
        model: MTimezone,
        initialize: function(models, opt) {
            // models = ProvincesData;
            this.set(data, { silent: true });
        },
    });

    return CTimezone;

});

